// extracted by mini-css-extract-plugin
export var article = "SectionsWithInnerCta-module--article--0878d";
export var articleBgImage = "SectionsWithInnerCta-module--article-bg-image--5a00b";
export var articleContainer = "SectionsWithInnerCta-module--article-container--afd85";
export var articleFullBg = "SectionsWithInnerCta-module--article-full-bg--d930c";
export var articles = "SectionsWithInnerCta-module--articles--50c35";
export var cta = "SectionsWithInnerCta-module--cta--ddec0";
export var description = "SectionsWithInnerCta-module--description--6c150";
export var header = "SectionsWithInnerCta-module--header--0b0fd";
export var image = "SectionsWithInnerCta-module--image--a8ef6";
export var links = "SectionsWithInnerCta-module--links--9d32d";